var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tms-dashboard" }, [
    _c("div", { staticClass: "content-body" }, [
      _c("div", { staticClass: "nav-bar-container" }, [
        _c("div", { staticClass: "nav-bar clearfix" }, [
          !_vm.isTenant
            ? _c("div", { staticClass: "welcome" }, [
                _c("span", { staticClass: "summary-hello" }, [
                  _vm._v(_vm._s(_vm.$t("hello"))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "summary-name" }, [
                  _vm._v(
                    _vm._s(
                      (_vm.currentUserContact || {}).name ||
                        _vm.currentUser.name
                    )
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tenant-dashboard__wrapper" },
        [
          _vm.canReadTenancyRecord
            ? _c("TenancyRecords", {
                attrs: {
                  preload: !!_vm.tenancyRecords,
                  preloadedTenancies: _vm.tenancyRecords || [],
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.canReadHotb
            ? _c("HandoverTakeback", {
                attrs: {
                  preload: !!_vm.handoverTakeback,
                  preloadedHotb: _vm.handoverTakeback || [],
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.canReadProject
            ? _c("MyTenantProjects", {
                staticClass: "margin-top",
                attrs: {
                  preload: !!_vm.tenantProjects,
                  preloadedTenantProjects: _vm.tenantProjects || [],
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.enableWorkPermitsFeature &&
          (_vm.canReadProject || _vm.canCreateStandalone)
            ? _c("WorkPermits", {
                attrs: {
                  hasAccess: _vm.canReadProject || _vm.canCreateStandalone,
                  tenancyRecords: _vm.tenancyRecords || [],
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }